<template>
<div class="chapter">
<div class="inner_page">
<p class="h1l" id="d7e150717">Things to Remember </p>
<p class="ext" id="d7e151217">A friend loves at all times, and a brother is born for adversity.</p>
<p class="ext1" id="d7e152017">PROVERBS 17:17 NKJV </p>
<p class="ext" id="d7e153417">Greater love has no one than this, than to lay down one’s life for his friends.</p>
<p class="ext1" id="d7e154217">JOHN 15:13 NKJV </p>
<p class="ext" id="d7e155617"><b>It is mutual respect which makes friendship lasting. </b></p>
<p class="ext1" id="d7e156417"><b>—JOHN HENRY NEWMAN </b></p>
<p class="ext" id="d7e158517">A man who has friends must himself be friendly, but there is a friend who sticks closer than a brother.</p>
<p class="ext1" id="d7e159317">PROVERBS 18:24 NKJV </p>
<p class="ext" id="d7e160717"><b>God evidently does not intend us all to be rich or powerful or great, but He does intend us all to be friends.</b></p>
<p class="ext1" id="d7e162817"><b>—RALPH WALDO EMERSON </b></p>
<p class="ext" id="d7e164717">Wounds from a friend can be trusted, but an enemy multiplies kisses.</p>
<p class="ext1" id="d7e165517">PROVERBS 27:6 NIV </p>
<p class="ext" id="d7e166917">No longer do I call you servants, for a servant does not know what his master is doing; but I have called you friends, for all things that I heard from My Father I have made known to you.</p>
<p class="ext1" id="d7e168717">JOHN 15:15 NKJV </p>
<p class="ext" id="d7e170117">Encourage each other every day while it is “today.” Help each other so none of you will become hardened because sin has tricked you.</p>
<p class="ext1" id="d7e171517">HEBREWS 3:13 NCV </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Inc_9781418557720_epub_c13_r1.vue?179c9539